import { useContext } from "react";
import OTPStepForm from "../../CreateAccount/OTPStepForm";
import { AccountInfoContext } from "./AccountInfoContext";

/**
 * A component for the OTP step in the account info step of the booking.
 *
 * It is simply a wrapper around the OTPStepForm component that provides it with the necessary values from the context
 *
 * @returns {JSX.Element}
 */

const AccountInfoOTPStep = () => {
  const { email, finishOTP, unsetEmail, timer, setTimer } =
    useContext(AccountInfoContext);
  return (
    <OTPStepForm
      email={email}
      finishOTP={finishOTP}
      unsetEmail={unsetEmail}
      timer={timer}
      setTimer={setTimer}
    />
  );
};

export default AccountInfoOTPStep;
